export const EZLO_PLUGINS_BUILD_PLUGIN_DOWNLOAD_URL_INVALID_PARAMS =
    'validateBuildPluginDownloadUrlParams: not valid params!';
